import type { MarketFinish } from "./market";

/**
 * Games never mix in the market and the store's lists: the visitor picks one (src/lib/GameProvider.tsx,
 * the header's switcher) and every list asks for it with this query parameter. The server falls back
 * to the first open game (server/lib/games.ts), so leaving it out means Pokémon.
 */
export const GAME_PARAM = "juego";
export const GAME_SLUG_RE = /^[a-z0-9-]{1,40}$/;

/** A query value as a game slug, else null (the server's default). */
export const gameSlug = (value: string | null | undefined): string | null => (value && GAME_SLUG_RE.test(value) ? value : null);

/**
 * The finishes a listing of each game can have. Pokémon prints reverse holo, holo and 1st edition of
 * the same card; One Piece's parallels, alt arts and manga are products of their own in the catalog,
 * so its listings are plain. A game not set up here gets only "normal".
 */
const GAME_FINISHES: Record<string, readonly MarketFinish[]> = {
  pokemon: ["normal", "holo", "reverse", "first_edition"],
  "one-piece": ["normal"],
};

export const gameFinishes = (game: string | null | undefined): readonly MarketFinish[] => GAME_FINISHES[game ?? ""] ?? ["normal"];

/** Short names sellers write for a game in a sheet's "juego" column, besides its slug and names. */
const GAME_ALIASES: Record<string, readonly string[]> = {
  pokemon: ["pkm", "pkmn", "ptcg", "pokemon tcg"],
  "one-piece": ["op", "optcg", "one piece tcg", "one piece card game"],
};

export const gameAliases = (game: string): readonly string[] => GAME_ALIASES[game] ?? [];
